import { RewardsIconSchema } from "@apps/rewards/schemas/RewardsIconSchema";
import { DiscountRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { FreeProductDiscountCodeRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { GiftCardRewardSchema } from "@apps/rewards/schemas/RewardsRewardSchemas/RewardsGiftCardRewardSchema";
import {
    array,
    assign,
    literal,
    nullable,
    number,
    object,
    omit,
    string,
    union,
} from "superstruct";

import { CUSTOMER_ACTIVE_REWARDS_TYPES } from "../constants";
import { CustomerRewardsActivitySchema } from "./RewardsCustomerRewardsActivitySchema";

export const CustomerDiscountCodeRewardSchema = assign(
    omit(DiscountRewardSchema, ["expirationInDays", "minimumOrderAmount"]),
    object({
        endsAt: nullable(string()),
        minOrderAmount: nullable(number()),
        maxShippingPrice: nullable(number()),
        countryCodes: nullable(array(string())),
        usageLimit: nullable(number()),
        usageCount: number(),
    })
);

const CustomerFreeProductDiscountCodeRewardSchema = assign(
    FreeProductDiscountCodeRewardSchema,
    object({
        endsAt: nullable(string()),
    })
);

const CustomerActiveRewardsBaseSchema = object({
    id: number(),
    reward: union([
        CustomerDiscountCodeRewardSchema,
        CustomerFreeProductDiscountCodeRewardSchema,
        GiftCardRewardSchema,
    ]),
    createdAt: string(),
});

const CustomerActiveRewardsEarningRuleSchema = assign(
    CustomerActiveRewardsBaseSchema,
    object({
        type: literal(CUSTOMER_ACTIVE_REWARDS_TYPES.reward),
        earningRule: CustomerRewardsActivitySchema,
    })
);

const CustomerActiveRewardsSpendingRuleSchema = assign(
    CustomerActiveRewardsBaseSchema,
    object({
        type: literal(CUSTOMER_ACTIVE_REWARDS_TYPES.redeem),
        spendingRule: CustomerRewardsActivitySchema,
    })
);

const CustomerActiveRewardsTierSchema = assign(
    CustomerActiveRewardsBaseSchema,
    object({
        type: literal(CUSTOMER_ACTIVE_REWARDS_TYPES.tier),
        tier: CustomerRewardsActivitySchema,
    })
);

const CustomerActiveRewardsReferredSchema = assign(
    CustomerActiveRewardsBaseSchema,
    object({
        type: literal(CUSTOMER_ACTIVE_REWARDS_TYPES.referred),
        referred: object({
            title: string(),
            icon: nullable(RewardsIconSchema),
        }),
    })
);

const CustomerActiveRewardsReferrerSchema = assign(
    CustomerActiveRewardsBaseSchema,
    object({
        type: literal(CUSTOMER_ACTIVE_REWARDS_TYPES.referrer),
        referrer: object({
            title: string(),
            icon: nullable(RewardsIconSchema),
        }),
    })
);

export const CustomerActiveRewardsSchema = union([
    CustomerActiveRewardsEarningRuleSchema,
    CustomerActiveRewardsSpendingRuleSchema,
    CustomerActiveRewardsTierSchema,
    CustomerActiveRewardsReferredSchema,
    CustomerActiveRewardsReferrerSchema,
]);

export const CustomerActiveRewardsResponseSchema = object({
    rewards: array(CustomerActiveRewardsSchema),
});
